<template>
    <a-form
        v-on:submit="submitForm"
        layout="vertical"
        :form="form"
    >
        <a-form-item
            label="E-mail cím"
        >
            <a-input
                v-decorator="[
                    'email',
                    {
                        preserve: true,
                        rules: [{
                            required: newUser,
                            message: 'Kérjük adjon meg egy helyes e-mail címet.',
                            type: 'email'
                        }]
                    }
                ]"
            >
            </a-input>
        </a-form-item>
        <a-form-item
            label="Jelszó"
        >
            <a-input
                v-decorator="[
                    'password',
                    {
                        preserve: true,
                        rules: [
                            {
                                required: newUser,
                                message: 'Kérjük adjon meg jelszavat',
                            }
                        ]
                    }
                ]"
                :type="showPassword ? 'text' : 'password'"
            ></a-input>
            <a-checkbox
                :checked="showPassword"
                v-on:change="showPasswordHandler"
            >
                Jelszó megjelenítése
            </a-checkbox>
        </a-form-item>
        <a-form-item
            label="Telefonszám"
        >
            <a-input
                v-decorator="[
                    'phone',
                    {
                        preserve: true,
                        rules: [
                            {
                                required: newUser,
                                message: 'Kérjük adjon meg telefonszámot',
                            }
                        ]
                    }
                ]"
            ></a-input>
        </a-form-item>
        <a-form-item
            label="Jogosultság"
        >
            <a-select
                mode="multiple"
                v-decorator="[
                    'roles',
                    {
                        preserve: true,
                        rules: [{
                            required: newUser,
                            message: 'Kérjük válasszon jogosultsági szintet.'
                        }]
                    }
                ]"
            >
              <a-select-option
                v-for="role in appRoles"
                :key="role.value"
                :value="role.value"
               >
                {{ role.name }}
              </a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item
        >
            <a-button
                icon="enter"
                type="primary"
                html-type="submit"
            >   
                Beküldés
            </a-button>
        </a-form-item>
    </a-form>
</template>

<script>
export default {
    props: {
        formValues: {
            type: Object,
            default: () => {
                return {
                    email: '',
                    password: '',
                    phone: '',
                    roles: []
                }
            }
        },
        newUser: {
            type: Boolean,
            default: true
        }
    },

    created() {
        this.form = this.$form.createForm(this, {
            onValuesChange: (_, values) => {
                this.$emit('formValuesChange', {
                    values
                });                
            }
        }) 
    },

    mounted() {
        this.form.setFieldsValue(this.formValues);
    },

    data() {
        return {
            showPassword: false,
            appRoles: [
                {
                    value: 'ROLE_ADMIN',
                    name: 'Admin'
                },
                {
                    value: 'ROLE_ADVANCED_USER',
                    name: 'Kiemelt felhasználó'
                },
                {
                    value: 'ROLE_USER',
                    name: 'Felhasználó'
                }
            ]
        }
    },


    methods: {
        submitForm(e) {
            if (e) {
                e.preventDefault();
            }
            this.form.validateFieldsAndScroll((err, vals) => {
                console.log('ERR', err);
                console.log('VALS', vals);
                if (!err) {
                    this.$emit('formSubmitted', vals);
                }
            })

        },

        showPasswordHandler(e) {
            this.showPassword = e.target.checked;
        }
    },

    watch: {
        formValues(newVal) {
            this.form.setFieldsValue({
                ...newVal
            })
        }
    }

}
</script>

<style>

</style>